var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentCredit.student && _vm.studentCredit.student.id)?_c('div',[_c('StudentProfileHeader',{staticClass:"mb-6",attrs:{"student":_vm.studentCredit.student}}),_c('CreditUsageTable')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }